import React from 'react'
import cx from 'classnames'

import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

import { TYPES } from '~/actions'
import Header from '~/components/Header'
// import SubHeader from '~/components/Header/SubHeader'

const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'absolute',
    width: theme.gofind.asideWidth,
    zIndex: 1000,
    left: 0,
    height: '100%',
    overflow: 'hidden',
    boxShadow: theme.shadows[5],
    background: theme.palette.background.paper,
    zIndex: 1000,
    left: 0,

    display: 'flex',
    flexDirection: 'column',
    transition: '.3s ease',
    transitionDelay: '.3s'
  },
  bar: {
    height: '100%',
    width: '100%',
    overflow: 'auto'
  },
  subHeader: {
    padding: 16,
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  withHeaderBg: {
    paddingTop: 0,
    transition: 'none'
  }
}))

const views = [
  TYPES.VIEW_PRODUCTS,
  TYPES.VIEW_SEARCH_PRODUCTS,
  TYPES.VIEW_STORES,
  TYPES.VIEW_PRODUCT_DETAILS
]

function Sidebar({ view, children, position, config }) {
  const classes = useStyles()
  const withHeaderBg = [TYPES.VIEW_PRODUCTS, TYPES.VIEW_SEARCH_PRODUCTS].includes(view)

  return TYPES.VIEW_EMPTY !== view ? (
    <Grid
      component="aside"
      className={cx(classes.wrapper, { [classes.withHeaderBg]: withHeaderBg })}
    >
      <Grid className={classes.headerBackground}>
        <Header config={config} position={position} />
      </Grid>

      {views.map((key) =>
        view !== key ? null : (
          <SimpleBar className={classes.bar} key={key}>
            {children}
          </SimpleBar>
        )
      )}

      {view === TYPES.VIEW_STORE_DETAILS && <Grid style={{ width: '100%' }}>{children}</Grid>}
    </Grid>
  ) : (
    <Header config={config} position={position} />
  )
}

export default Sidebar
